import { ACTION_TYPES, Actions } from "./types"
import { Action } from "./actions"

export const INVENTORY_STOCK_DOCUMENT_DEFINITION_ACTION_TYPES = ACTION_TYPES
export const InventoryStockDocumentDefinitionAction = Action
export type InventoryStockDocumentDefinitionActions = Actions




// WEBPACK FOOTER //
// ./src/state/inventory/stockDocumentDefinition/actions/index.ts